"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(state, services, actions, action) {
  var fragment = "\n    id\n    name\n    lastName\n    email\n    accessToken\n  ";
  var resolvedActions = actions.user ? actions.user : actions.userAction;
  services.user.loadCurrentUser(fragment, resolvedActions);
};

var updateAccessToken = exports.updateAccessToken = function updateAccessToken(state, services, actions, action) {
  var resolvedActions = actions.user ? actions.user : actions.userAction;
  resolvedActions.updateAccessToken(action.data);
};

var fetchLoyalty = exports.fetchLoyalty = function fetchLoyalty(state, services, actions) {
  if (!state.user.currentUser) {
    return;
  }
  var resolvedActions = actions.loyaltyCard ? actions.loyaltyCard : actions.loyaltyCardAction;
  services.loyaltyCard.getActiveCard({ user: state.user.currentUser.id }, resolvedActions);
};

var fetchUserOrders = exports.fetchUserOrders = function fetchUserOrders(state, services, actions) {
  if (!state.user.currentUser) {
    return;
  }
  var resolvedActions = actions.user ? actions.user : actions.userAction;

  var filters = { limit: 50 };
  if (state.app.id) {
    filters.app = state.app.id;
  }
  services.user.loadUserOrders(filters, resolvedActions);
};

var reloadCreditCards = exports.reloadCreditCards = function reloadCreditCards(state, services, actions, action) {
  var resolvedActions = actions.user ? actions.user : actions.userAction;
  services.user.loadCreditCards(state.app.id, resolvedActions);
};

var fetchVouchers = exports.fetchVouchers = function fetchVouchers(state, services, actions) {
  var resolvedActions = actions.voucher ? actions.voucher : actions.voucherAction;
  services.voucher.getMine(resolvedActions);
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/middleware-helpers/user.js
// module id = 415
// module chunks = 0